import { createContext, useContext, useCallback } from "react";
import { PDFDocument } from "pdf-lib";
import { fetchFilePdf } from "@services/export";
import logger from "@utils/logger";

const PDFContext = createContext();

export const usePDF = () => useContext(PDFContext);

export const PDFProvider = ({ children }) => {
  const handleExportPDF = useCallback(async (fileId, fileName, date) => {
    try {
      logger.info(`Starting PDF export for file ID: ${fileId}`);
      const response = await fetchFilePdf(fileId);
      const formattedDate = new Date(date).toISOString().split("T")[0]; // "YYYY-MM-DD"
    
    // Construct the PDF name with the fileName and date
    const namePDF = `${fileName || "Untitled"}.pdf`;
      const blob = await response.blob();

      // Modify PDF title
      const pdfDoc = await PDFDocument.load(await blob.arrayBuffer());
      pdfDoc.setTitle(namePDF);
      const modifiedBytes = await pdfDoc.save();
      const modifiedBlob = new Blob([modifiedBytes], {
        type: "application/pdf",
      });

      // Trigger download
      const url = window.URL.createObjectURL(modifiedBlob);
      window.open(url, "_blank");
      const anchor = document.createElement("a");
      anchor.href = url;
      anchor.download = namePDF;
      anchor.click();
      window.URL.revokeObjectURL(url);

      logger.info(`PDF export completed for file ID: ${fileId}`);
    } catch (error) {
      logger.error(`Error exporting PDF for file ID: ${fileId}`, error);
    }
  }, []);

  return (
    <PDFContext.Provider  value={{ handleExportPDF }}>
      {children}
    </PDFContext.Provider>
  );
};
